import { Breadcrumbs, Theme, Typography, Grid, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import KenColors from "../../Helpers/Themes/kenColors";
import { useAuthContext } from "../../Helpers/Contexts/authContext";

const useStyles = makeStyles((theme: Theme) => ({
  mainText: {
    // fontSize: '20px !important',
    fontWeight: "600 !important",
    textDecoration: "none",
    textTransform: "capitalize",
    margin: "0px !important",
    padding: "0px !important",
    "@media (min-width: 1280px) and (max-width: 1300px)": {
      fontSize: "13px !important",
    },
    "@media (min-width: 1920px) and (max-width: 1940px)": {
      fontSize: "20px !important",
    },
  },
  listText: {
    textDecoration: "none",
    textTransform: "capitalize",
    margin: "0px !important",
    padding: "0px !important",
  },
}));

const AppBreadCrumbs: React.FunctionComponent = () => {
  const { pathname, state } = useLocation();
  const { state: AuthState } = useAuthContext();
  const { user } = AuthState;
  const theme = useTheme();
  const is1440 = useMediaQuery("@media (max-width: 1440px)");
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md")); // Matches screens <= 'md'
  const classes = useStyles();
  
  const getCustomBreadcrumbs = (path: string): Array<{ label: string; path: string }> | null => {
    if (path === "/exams/results") {
      return [
        { label: "Exams", path: "/exams" },
        { label: "Results", path: "/exams/results" },
      ];
    }
    if (path === "/exams/marks-breakdown") {
      return [
        { label: "Exams", path: "/exams" },
        { label: "Results", path: "/exams/results" },
        { label: "Marks Breakdown", path: "/exams/marks-breakdown" },
      ];
    }
    if (path === "/exams/grade-cards-download") {
      return [
        { label: "Exams", path: "/exams" },
        { label: "Results", path: "/exams/results" },
        { label: "Grade Cards Download", path: "/exams/grade-cards-download" },
      ];
    }
    // Default behavior for other routes
    return null;
  };

  const customBreadcrumbs = getCustomBreadcrumbs(pathname);
  const navigateHistory: Array<string> = decodeURIComponent(pathname)
    .split("/")
    .filter((items) => {
      return items && items !== "";
    });
  const navigateState: null | string = state?.breadCrumbs;
  let customPath: string = "";

  return (
    <>
      {navigateHistory[0] === "home" ? (
        <Typography variant={is1440 ? "mediumthin" : "largethin"}>
          Welcome, <Typography variant={is1440 ? "mediumbold" : "largebold"}>{user?.applicantName}</Typography>
        </Typography>
      ) : (
        <Typography className={classes.mainText} color={KenColors.ClientBlack2} fontSize={"0.9375rem"}>
          {customBreadcrumbs ? "Exams" : navigateHistory[0]}
        </Typography>
      )}
      {navigateHistory[0] === "home"
        ? null
        : (customBreadcrumbs || navigateHistory.length > 1) && (
            <Grid style={isMobileOrTablet ? { margin: "3px 20px" } : {}}>
              <Breadcrumbs separator={<Typography sx={{ fontSize: "0.75rem", fontWeight: "500" }}>&gt;</Typography>} style={{ color: "#3061FF" }}>
                {customBreadcrumbs ? (
                  customBreadcrumbs.map((crumb, index) => {
                    const isLastIndex = index === customBreadcrumbs.length - 1;
                    return (
                      <Link key={index} className={classes.listText} to={crumb.path}>
                        <Typography sx={{ color: isLastIndex ? KenColors.ClientBlack2 : "#3061FF", fontWeight: isLastIndex ? "400" : "600", fontSize: "0.75rem" }}>{crumb.label}</Typography>
                      </Link>
                    );
                  })
                ) : (
                  navigateHistory.map((items, index) => {
                    customPath = customPath + `;${items}`;
                    const isLastIndex = index === navigateHistory.length - 1;
                    const newPath = customPath.replace(/;/g, "/");
                    let newItem = items.replace(/-/g, " ");
                    return index === navigateHistory.length - 1 && navigateState ? (
                      <Typography key={index} className={classes.listText} color={"#193389"} fontSize={"0.75rem"}>
                        {navigateState}
                      </Typography>
                    ) : (
                      <Link key={index} className={classes.listText} to={`${newPath}`}>
                        <Typography sx={{ color: isLastIndex ? KenColors.ClientBlack2 : "#3061FF", fontWeight: isLastIndex ? "400" : "600", fontSize: "0.75rem" }}>{newItem}</Typography>
                      </Link>
                    );
                  })
                )}
              </Breadcrumbs>
            </Grid>
          )}
    </>
  );
};

export default AppBreadCrumbs;
